









import { Vue, Component, Prop } from "vue-property-decorator";
@Component({})
export default class HideShowInput extends Vue {
  @Prop()
  msg!: string;
  type: string = "password";
  @Prop({default:false})
  isError?:boolean;

  showMsg() {
    this.type = this.type === "password" ? "text" : "password";
  }
}
